import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { TFunction } from 'i18next'
import React from 'react'
import { usePriceElement } from './hooks/usePriceElement'
import { CommonPriceElementGroup } from './price-element-group'
import {
  PricePlanPeriodType,
  UserPlansResponseInterface,
} from './price-element-interface'
import { CommonPriceElementPeriod } from './price-element-period'
import { CommonPriceElementPlans } from './price-element-plans'
import {
  CommonPriceElementContainerUi,
  CommonPriceElementPlanContainerUi,
  CommonPriceElementPlansWrapperUi,
  CommonPriceElementSubtitle,
  CommonPriceElementTableContainerUi,
  CommonPriceElementWrapperUi,
  PCommonPriceElementPlanItemUi,
} from './ui'

interface CommonPriceElementProps {
  locale: PageLocaleEnum
  pricePlans: UserPlansResponseInterface[] | null
  isLoading: boolean
  openPopup: (id: number, activeBtn: PricePlanPeriodType) => void
  t: TFunction
  isWebsitePage?: boolean
}

export const CommonPriceElement = ({
  locale = PageLocaleEnum.ENGLISH,
  pricePlans,
  isLoading,
  openPopup,
  t,
  isWebsitePage,
}: CommonPriceElementProps) => {
  const { activeBtn, priceGroup, pricePeriod, togglePeriod } = usePriceElement({
    locale,
    pricePlans,
    isWebsitePage,
  })

  return (
    <CommonPriceElementWrapperUi>
      <CommonPriceElementContainerUi>
        <CommonPriceElementPlansWrapperUi>
          <CommonPriceElementPeriod
            locale={locale}
            activeBtn={activeBtn}
            onClick={togglePeriod}
            t={t}
            isLoading={isLoading}
          />
          <CommonPriceElementPlans
            locale={locale}
            plans={pricePeriod}
            onClick={openPopup}
            t={t}
            activeBtn={activeBtn}
            isLoading={isLoading}
          />
        </CommonPriceElementPlansWrapperUi>
        <CommonPriceElementSubtitle>
          {t('components.price_element.compare_plans_title')}
        </CommonPriceElementSubtitle>
        <CommonPriceElementTableContainerUi>
          <CommonPriceElementPlanContainerUi planCount={pricePeriod.length}>
            <div />
            {pricePeriod.map(({ title, id }) => (
              <PCommonPriceElementPlanItemUi key={id}>
                {title}
              </PCommonPriceElementPlanItemUi>
            ))}
          </CommonPriceElementPlanContainerUi>
          {priceGroup.map(el => (
            <CommonPriceElementGroup
              key={el.id}
              pricePeriod={pricePeriod}
              locale={locale}
              t={t}
              data={el}
              isLoading={isLoading}
            />
          ))}
        </CommonPriceElementTableContainerUi>
      </CommonPriceElementContainerUi>
    </CommonPriceElementWrapperUi>
  )
}
